import styled from 'styled-components';

import { Tabs as TabsComponent } from 'components/tabs';

export const Tabs = styled(TabsComponent)`
  padding: 0 32px;
`;
